import { Components, Theme, ThemeOptions } from '@mui/material/styles';

const getInputLabelTheme = (_theme: Theme): ThemeOptions => {
  const inputLabelTheme: Components<Theme>['MuiInputLabel'] = {
    styleOverrides: {
      root: {},
    },
  };

  return {
    components: {
      MuiInputLabel: inputLabelTheme,
    },
  };
};

export default getInputLabelTheme;
